const LOGOUT_RETURN_TO_KEY = "logout:return-to";

const isSafeAppPath = (value: string): boolean =>
  value.startsWith("/") && !value.startsWith("//") && value !== "/logout";

export const saveLogoutReturnTo = (): void => {
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (!isSafeAppPath(path)) return;

  sessionStorage.setItem(LOGOUT_RETURN_TO_KEY, path);
};

export const getLogoutReturnTo = (): string => {
  const storedValue = sessionStorage.getItem(LOGOUT_RETURN_TO_KEY);
  if (!storedValue || !isSafeAppPath(storedValue)) return "/";

  return storedValue;
};
